module.exports = __webpack_public_path__ + "media/2x/J-eff7cb85.png";